import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import mp from './ManufacturersPage.module.scss';
import Image from 'next/image';
import Rectangle from '/public/static/images/Rectangle.webp';
import WithMainContainer from '@/components/layout';
import g from '../../general.module.scss';
import { Flex, Layout, Select, Typography, Input, Pagination } from 'antd';
import logo from '/public/static/images/image_logo_full.svg';
import Head from 'next/head';
import { useStores } from '@/utils/hooks/useStores';
import useLocalization from 'tkmp-lib/src/hooks/useLocalization';
import { QueryService } from 'tkmp-lib/src/services/QueryService';
import HeadService from '@/utils/services/HeadService';

export async function getServerSideProps(context: any) {
    const cookies = context?.req?.cookies;

    const locale = QueryService.getLocale(context);

    if (cookies) {
        const dto = await QueryService.request(
            `${process.env.NEXT_PUBLIC_DOMAIN_BFF}/tkmp/v1/${locale}/organisation/all`,
        );

        return {
            props: {
                manufacturersDto: dto,
            },
        };
    }
    return {
        props: {
            manufacturersDto: null,
        },
    };
}

function ManufacturersPage({ manufacturersDto }: any) {
    const [manufacturers, setManufacturers] = useState(manufacturersDto);

    useEffect(() => {
        setManufacturers(manufacturersDto);
    }, [manufacturersDto]);

    const [cardArr] = useState([...Array(6)].fill(1));
    const LOCALIZATION = useLocalization();

    const {
        systemStore: { setBreadcrumbs },
    } = useStores();

    useEffect(() => {
        setBreadcrumbs([
            {
                key: '/',
                title: LOCALIZATION.routes.home,
            },
            {
                key: '/manufacturers',
                title: LOCALIZATION.pages.manufacturers.manufacturers_title,
            },
        ]);
    }, [LOCALIZATION]);

    return (
        <>
            {process.env.NEXT_PUBLIC_INCLUDE_SEO_TAGS === 'true' &&
                HeadService.simpleBuild(
                    'Производители, использующие TKMP.Istok для бизнеса',
                    '/manufacturers',
                )}
            <Flex
                vertical
                className={`${g.mainContainer} ${mp.container}`}
            >
                <Typography.Text className="text-24-500">
                    {LOCALIZATION.pages.manufacturers.manufacturers_title}
                </Typography.Text>
                <Flex
                    className={mp.header}
                    justify={'space-between'}
                >
                    <Input style={{ width: '316px' }} />
                    <Select style={{ width: '260px' }} />
                </Flex>
                <Layout className={mp.manufacturersGrid}>
                    {manufacturers.map((item: any, i: any) => {
                        return (
                            <Link
                                key={i}
                                href={`/manufacturer/${item.slug}`}
                                className={mp.card}
                            >
                                <Image
                                    src={`${process.env.NEXT_PUBLIC_DOMAIN_CDN}${item.logo}`}
                                    width={142}
                                    height={142}
                                    sizes={'100%'}
                                    alt={item.slug}
                                />
                                <Flex
                                    vertical
                                    className={mp.cardText}
                                >
                                    <Typography.Text className="text-16-500 text-[#0B0B0C]">
                                        {item.name}
                                    </Typography.Text>
                                    <Typography.Text
                                        className={`text-16-400 text-[#0B0B0C] ${mp.description}`}
                                    >
                                        {item.description}
                                    </Typography.Text>
                                </Flex>
                            </Link>
                        );
                    })}
                </Layout>
                <Pagination align={'center'} />
            </Flex>
        </>
    );
}

export default WithMainContainer(ManufacturersPage);
